import { BuildClass, fsmData, fsmoData, genRandomHexString, } from '../../../universal';
import { React, _ } from '../../lib';
import { isDarkTheme } from '../component-main';
import { Box } from './box';
import { LoadingSpinnerLarge } from './loading';
import { CJSX, useStateSync } from './meta-types';
export const TabControlNavigation = (props) => {
    const [data, setData] = React.useState(props.value ?? {
        selected: null,
        tabs: {},
    });
    useStateSync({
        stateVal: data,
        propVal: props.value ?? data,
        setState: setData,
        setProp: v => {
            props.onUpdate?.(v);
            props.savePersistentData({
                selected: v.selected,
                tabs: fsmoData(v.tabs, {
                    sort: x => x.order,
                    map: tab => [tab.value, _.omit(tab, 'boxProps')],
                }),
            });
        },
        compareFn: (p, s) => p === s,
    });
    const hiddenInput = React.useRef(null);
    const actionFocus = () => {
        if (!props.disableFocusControl) {
            hiddenInput.current?.focus();
        }
    };
    const moveSelection = (delta) => {
        const tabs = _.filter(data.tabs, x => !x.hidden);
        const max = tabs.length - 1;
        const index = tabs.map(x => x.value).indexOf(data.selected ?? '');
        let newIndex = index + delta;
        if (newIndex < 0) {
            newIndex = 0;
        }
        else if (newIndex > max) {
            newIndex = max;
        }
        setData(s => ({
            ...data,
            selected: tabs[newIndex]?.value ?? s.selected,
        }));
    };
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {
        props.loadPersistentData().then(dataRaw => {
            console.log(dataRaw);
            const D = {
                selected: dataRaw.selected ?? null,
                tabs: fsmoData(dataRaw.tabs ?? {}, {
                    sort: x => x.order,
                    map: tab => [
                        tab.value,
                        {
                            ...tab,
                            boxProps: getBoxProps(tab.boxPropFunc),
                        },
                    ],
                }),
            };
            if (Object.keys(D.tabs).length === 0) {
                const newTab = getNewTab(props.getNewTab(), 1);
                D.selected = newTab.value;
                D.tabs = { [newTab.value]: newTab.tab };
            }
            if (!D.selected || _.find(D.tabs, x => x.value === D.selected)?.hidden) {
                D.selected = _.find(D.tabs, x => !x.hidden)?.value ?? null;
            }
            console.log({ D });
            setData(D);
            setLoaded(true);
        });
    }, []);
    const isDark = isDarkTheme();
    const tabWrapper = () => (React.createElement("div", { className: "flex" },
        React.createElement("div", { className: "flex-none" }, props.toolbarBefore),
        React.createElement("div", { className: "flex-1", onClick: actionFocus },
            React.createElement("div", { className: BuildClass({
                    'flex w-[calc(100%+1px)] h-8 p-0 -mx-px': true,
                    'overflow-hidden select-none': true,
                    'bg-[hsl(0,0,90%)]': true,
                    'bg-[hsl(0,0,10%)]': isDark,
                }) },
                fsmData(data.tabs, {
                    filter: tab => !tab.hidden,
                    map: tab => {
                        const title = tab.boxProps.getTitle(tab.state);
                        const isDisabled = tab.disabled ?? false;
                        const isSelected = tab.value === data.selected;
                        return (React.createElement("div", { key: tab.value, className: BuildClass({
                                'group/lbl': true,
                                'flex-1 relative overflow-hidden': true,
                                'max-w-[200px] float-left -mr-[5px]': true,
                                'active:top-[2px]': !isDisabled,
                                'z-[1]': isSelected,
                                'cursor-pointer': true,
                                'cursor-default': isDisabled || isSelected,
                                'h-full': true,
                                'h-[calc(100%-1px)]': !isSelected,
                            }), title: title, onMouseDown: () => {
                                if (!tab.disabled) {
                                    setData({ ...data, selected: tab.value });
                                }
                            } },
                            React.createElement("div", { className: BuildClass({
                                    'h-[calc(100%+2px)]': true,
                                    'border-t-[2px] border-x-[1px]': true,
                                    'border-solid': true,
                                    'transition-[background_0.2s,border-color_0.2s]': true,
                                    'group-hover/lbl:bg-[hsl(60,100%,90%)]': !isDisabled && !isSelected,
                                    'bg-white': isSelected,
                                    'rounded-[3px_3px_0_0]': isSelected,
                                    'border-[transparent]': true,
                                    'border-t-[hsl(233,100%,70%)]': isSelected,
                                    'border-x-[hsl(0,0,75%)]': isSelected,
                                }) }),
                            React.createElement("div", { className: BuildClass({
                                    'group/close': true,
                                    ['hidden']: !isSelected,
                                    'absolute z-[1] top-0 right-0': true,
                                    'border border-transparent': true,
                                    'rounded-full': true,
                                    'p-[3px] mx-[2px] my-[8px] leading-[0]': true,
                                    'hover:bg-[hsl(0,100%,40%)]': true,
                                }), title: "Close tab", onClick: () => {
                                    setData({
                                        ...data,
                                        selected: fsmData(data.tabs, {
                                            filter: x => x.order < tab.order,
                                            sort: x => x.order,
                                            reverse: true,
                                            takeFirst: true,
                                            map: x => x?.value ??
                                                _.find(data.tabs, y => y.value != tab.value)?.value,
                                        }),
                                        tabs: fsmoData(data.tabs, {
                                            filter: x => x.value !== tab.value,
                                        }),
                                    });
                                } },
                                React.createElement("img", { className: BuildClass([
                                        'grayscale w-[10px]',
                                        'group-hover/close:brightness-0',
                                        'group-hover/close:invert',
                                    ]), src: "/static/img/svg/wmanage/cross.svg", alt: "Close tab" })),
                            React.createElement("div", { className: BuildClass({
                                    'tab-text': true,
                                    'absolute top-[7px] w-[calc(100%-2px)] pl-[2px] text-center text-lg': true,
                                    'leading-5': true,
                                    'border-r-[1px]': true,
                                    'transition-[border-color_0.2s,color_0.2s]': true,
                                    'whitespace-nowrap overflow-hidden text-ellipsis': true,
                                    'border-[transparent]': isSelected,
                                    'border-[hsl(0,0,40%)]': isSelected && isDark,
                                    'border-[hsl(0,0,75%)]': !isSelected,
                                    'group-hover/lbl:border-[transparent]': !isDisabled && !isSelected,
                                    'group-hover/lbl:border-[hsl(0,0,30%)]': !isSelected && !isDisabled && isDark,
                                    'text-[hsl(0,0,25%)]': true,
                                    'text-black': isSelected,
                                    'text-[hsl(0,0%,60%)]': isDisabled,
                                    'text-[hsl(0,0%,65%)]': isDark,
                                    'text-[hsl(0,0%,75%)]': isDark && isSelected,
                                    'group-hover/lbl:text-[hsl(0,0%,75%)]': isDark && !isDisabled && !isSelected,
                                }) }, title)));
                    },
                }),
                React.createElement("div", { className: BuildClass([
                        'ml-[5px] px-[6px] py-[9px]',
                        'border border-transparent rounded-md',
                        'hover:bg-[#fff] hover:border-[#888] cursor-pointer',
                    ]), onClick: () => {
                        const newTab = getNewTab(props.getNewTab(), Object.keys(data.tabs).length + 1);
                        setData(s => ({
                            ...s,
                            selected: newTab.value,
                            tabs: {
                                ...s.tabs,
                                [newTab.value]: newTab.tab,
                            },
                        }));
                    } },
                    React.createElement("img", { className: "w-[12px]", src: "/static/img/svg/plus-black.svg", alt: "Add new tab" })))),
        React.createElement("div", { className: "flex-none" }, props.toolbarAfter)));
    const content = () => (React.createElement("div", { className: "h-[calc(100%-32px)]" }, fsmData(data.tabs, {
        filter: tab => !tab.hidden && tab.value === data.selected,
        map: tab => (React.createElement("div", { key: tab.value, className: BuildClass({
                'h-full overflow-y-auto': true,
                ['hidden']: tab.value != data.selected,
                [tab.className ?? '']: true,
            }) },
            React.createElement(CJSX, { cond: !tab.disabled },
                React.createElement(Box, { ...getBoxProps(tab.boxPropFunc), state: tab.state, onUpdateState: v => {
                        setData(s => {
                            const existing = s.tabs[tab.value];
                            return existing
                                ? {
                                    ...s,
                                    tabs: {
                                        ...s.tabs,
                                        [tab.value]: {
                                            ...existing,
                                            state: v,
                                        },
                                    },
                                }
                                : s;
                        });
                    } })))),
    })));
    const focusController = () => (React.createElement("div", { className: "w-0 h-0 overflow-hidden" },
        React.createElement("input", { ref: hiddenInput, onKeyDown: e => {
                switch (e.keyCode) {
                    case 37:
                    case 38:
                        moveSelection(-1);
                        break;
                    case 39:
                    case 40:
                        moveSelection(+1);
                        break;
                    default:
                        return;
                }
                e.preventDefault();
                e.stopPropagation();
            } })));
    if (!loaded) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    return (React.createElement("div", { className: BuildClass({
            'w-full h-full': true,
            'bg-[hsl(0,0,14%)]': isDark,
            [props.className ?? '']: true,
        }) },
        focusController(),
        tabWrapper(),
        content()));
};
const getBoxProps = (func) => getFunctionFromString(window, func)();
const getFunctionFromString = (context, func) => {
    const [head, ...rest] = func.split('.');
    if (!head) {
        throw new Error('Invalid function path for getFunctionFromString');
    }
    if (rest.length > 0) {
        return getFunctionFromString(context[head], rest.join('.'));
    }
    return context[head];
};
const getNewTab = (tab, order) => {
    const value = genRandomHexString(16);
    return {
        value: value,
        tab: {
            value: value,
            boxProps: tab.boxProps,
            state: tab.boxProps.getInitialState(),
            boxPropFunc: tab.boxProps.func,
            order: order,
            className: tab.className,
            hidden: tab.hidden,
            disabled: tab.disabled,
        },
    };
};
//# sourceMappingURL=tab-nav.js.map